
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanysComponent } from './companys.component';

import { CreatecompanyComponent } from './createcompany/createcompany.component';
import { LoginGuardGuard } from '../services/service.index';
import { NopagefoundComponent } from '../shared/nopagefound/nopagefound.component';



const pageRoutes: Routes = [
  {
    path: 'company', component: CompanysComponent,
    canActivate: [ LoginGuardGuard ],
    children: [
      {  path: 'registercompany',  component: CreatecompanyComponent},
    ]
  },
  //{  path: '**',  component: NopagefoundComponent},
];

@NgModule({
  imports: [RouterModule.forChild(pageRoutes)],
  exports: [RouterModule]
})
export class CompanysRoutingModule { }
